import React from 'react';

/**
 * Reusable TabPanel component for managing tab content visibility
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Tab content
 * @param {number} props.value - Current active tab index
 * @param {number} props.index - This panel's tab index
 * @param {Object} props.other - Additional props
 * @returns {JSX.Element} TabPanel component
 */
const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{
        width: '100%',
        display: value === index ? 'block' : 'none'
      }}
      {...other}
    >
      {children}
    </div>
  );
};

export default TabPanel;
